/** saves list of states
@payload { Array }
*/
export const SAVE_MOBILE_PAYMENT_STATUS = (state, payload) => {
	state.paymentsRequestsStatusList = payload.paymentStatusViewList
}

/** saves list of payment requests
@payload { Array }
*/
export const SAVE_MOBILE_PAYMENT_REQUESTS_LIST = (state, { pageNumber, data }) => {
	state.paymentsRequestsList = pageNumber === 1 ? data.payments : state.paymentsRequestsList.concat(data.payments)
	state.paymentsRequestsHasMore = data.hasMore
}

/** saves payment detail
@payload { Array }
*/
export const SAVE_MOBILE_PAYMENT_DETAIL = (state, payload) => {
	state.paymentsDetail = payload
}

/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
	state.accountsBalances = payload.balanceViews
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_PAY_FEATURE_STATE = (state, payload) => {
	state.accountsBalances = []
}

export const CLEAR_CONSULT_FEATURE_STATE = (state, payload) => {
	state.paymentsRequestsStatusList = []
	state.paymentsRequestsList = []
	state.paymentsDetail = []
	state.paymentsRequestsHasMore = false
}
